import { Box, SxProps, Theme } from "@mui/material";

interface Props {
  src: string;
  sx?: SxProps<Theme>;
  objectFit?: "fill" | "contain" | "cover" | "none" | "scale-down";
  alt?: string;
}

/**
 * @param {object} props - The props of the Box.
 */
export default function ImageComponent({ src, sx, objectFit, alt = "image-component" }: Props) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", ...sx }}>
      <img src={src} width="100%" height="100%" alt={alt} style={{ objectFit }} />
    </Box>
  );
}
